import React from 'react';

interface CoreFeaturesProps {
  title: string
  blocks: { heading: string; description: string }[]
  className: string
}

const CoreFeatures: React.FC<CoreFeaturesProps> = ({ title, blocks, className }) => {
  return (
    <div className="rounded border border-grey-4 md:mb-6">
      <div className="shadow-thumbnail bg-gradient-model-grey rounded-t-lg">
        <div className="flex items-center py-1 px-4">
          <span className="text-black body-xs font-semibold">{title}</span>
        </div>
      </div>
      <div className="p-4 bg-grey-7">
        {blocks.map((block, index) => (
          <div
            key={index}
            className={`flex items-center ${index > 0 ? 'pt-2' : ''} ${
              index < blocks.length - 1 ? 'pb-2 border-b border-inverse' : ''
            }`}
          >
            <span dangerouslySetInnerHTML={{ __html: block.heading }}></span>
            <div className={className} dangerouslySetInnerHTML={{ __html: block.description }} />
          </div>
        ))}
      </div>
    </div>
  )
}

export default CoreFeatures
